import React from "react"
import PropTypes from "prop-types"

import ThemeConsumer from "../../../ThemeConsumer"
import HeaderPrimary from "./HeaderPrimary"
import HeaderSecondary from "./HeaderSecondary"

const ModalHeader = ({ headerVersion, ...props }) => {
  const Headers = {
    headerPrimary: HeaderPrimary,
    headerSecondary: HeaderSecondary
  }
  const Component = Headers[headerVersion] || HeaderPrimary

  return <Component {...props} />
}
ModalHeader.propTypes = {
  headerVersion: PropTypes.string
}
export default ThemeConsumer("UIModernModal")(ModalHeader)



// WEBPACK FOOTER //
// ./src/shared/components/ModernModal/components/ModalHeader/index.js